// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__JXob7","load1":"loading_load1__urBrT"};